import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { Injectable, Injector, DOCUMENT, inject } from '@angular/core';
import { BlockScrollStrategy, Overlay, OverlayConfig, ViewportRuler } from '@angular/cdk/overlay';

import { MyOverlayRef } from './myoverlay-ref';


@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  private overlay = inject(Overlay);
  private injector = inject(Injector);
  private _document = inject<Document>(DOCUMENT);
  private viewportRuler = inject(ViewportRuler);

  open<R = any, T = any>(
    content: ComponentType<R>,
    data: T,
    hasBackdrop = true,
    position?: 'centered' | 'right',
    panelClass?: string,
    scrollStrategy: 'none' | 'block-scroll' = 'none',
    activateCloseOnEscapeClick = true,
    activateCloseOnBackdropClick = true,
  ) {
    position = position ? position : 'centered';
    const centered = this.overlay.position().global().centerHorizontally().centerVertically();
    const right = this.overlay.position().global().top('0').right('0');
    const configs = new OverlayConfig({
      hasBackdrop,
      positionStrategy: position === 'centered' ? centered : right,
      panelClass: panelClass ? panelClass : '',
      // Don't auto-close product detail overlay on navigation
      disposeOnNavigation: panelClass !== 'product-detail-overlay',
      scrollStrategy: scrollStrategy === 'none' ? undefined : new BlockScrollStrategy(this.viewportRuler, this._document)
    });
    const overlayRef = this.overlay.create(configs);
    const myOverlayRef = new MyOverlayRef<R, T>(overlayRef, content, data);
    const injector = this.createInjector(myOverlayRef, this.injector);
    myOverlayRef.componentInstance = overlayRef.attach(new ComponentPortal(myOverlayRef.content, null, injector));
    myOverlayRef.activateCloseOnEscapeClick();
    // myOverlayRef.activateCloseOnBackdropClick();

    if (activateCloseOnEscapeClick) {
      myOverlayRef.activateCloseOnEscapeClick();
    }
    if (activateCloseOnBackdropClick) {
      myOverlayRef.activateCloseOnBackdropClick();
    }

    return myOverlayRef;
  }

  createInjector(ref: MyOverlayRef, inj: Injector) {
    return Injector.create({
      providers: [{ provide: MyOverlayRef, useValue: ref }],
      parent: inj
    });
  }
  createInjectorNew(ref: any, inj: Injector) {
    return Injector.create({
      providers: [{ provide: 'ref', useValue: ref }],
      parent: inj
    });
  }
}